import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { MdClose } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import QRCode from "qrcode";

const DeviceModal = ({ device, onClose, formatDate, getStatusColor }) => {

  const [qr, setQr] = useState("");

  const qrValue =
    device?.linked_key?.response_data?.gateway_meta?.qr_code_data;



  useEffect(() => {
    if (!qrValue) return;

    let valueToEncode;

    if (typeof qrValue === "string") {
      valueToEncode = qrValue;
    }

    else if (typeof qrValue === "object") {
      valueToEncode = JSON.stringify(qrValue);
    }


    if (qrValue) {
      QRCode.toDataURL(qrValue, {
        width: 100,
        margin: 2,
      })
        .then(setQr)
        .catch(console.error);
    }
  }, [qrValue]);

  const downloadQR = () => {
    const link = document.createElement("a");
    link.href = qr;
    link.download = "qr-code.png";
    link.click();
  };



  useEffect(() => {
    document.body.style.overflow = "hidden";
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  // if (!qrValue) return null;

  const sortedJourney = device?.linked_key?.response_data?.journey?.slice().sort(
    (a, b) => a.created_at - b.created_at
  );

  const modalContent = (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-2 bg-black bg-opacity-50" onClick={onClose}>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.2 }}
          className="relative w-full max-w-4xl overflow-hidden bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="sticky top-0 z-10 flex items-center justify-between px-2 py-2 bg-blue-600">
            <h3 className="text-lg font-semibold text-white">Device Details - {device.name}</h3>
            <button onClick={onClose} className="text-white transition-colors hover:text-gray-200">
              <MdClose className="w-6 h-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-2 space-y-1">
            {/* Basic Info */}
            <div className="p-2 border rounded-lg bg-gray-50">
              <h4 className="mb-2 text-sm font-semibold text-gray-700">Basic Information</h4>
              <div className="grid grid-cols-2 gap-2 text-sm md:grid-cols-3">
                <div className="flex flex-col gap-1">
                  <div><span className="font-medium">ID:</span> {device?.id}</div>
                  <div><span className="font-medium">User ID:</span> {device?.user_id}</div>
                  <div><span className="font-medium">Mobile:</span> {device?.mobile_number}</div>
                  <div><span className="font-medium">Status:</span>
                    <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${getStatusColor(device?.status)}`}>
                      {device?.status || "N/A"}
                    </span>
                  </div>

                  <div><span className="font-medium">Key Status:</span>
                    <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${getStatusColor(device?.key_status)}`}>
                      {device?.key_status || "N/A"}
                    </span>
                  </div>

                </div>
                <div className="flex flex-col gap-1">

                  <div><span className="font-medium">Running:</span>
                    <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${device?.running ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
                      {device?.running ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    <span className="font-medium">Auto Reminder Enabled:</span>

                    {device?.linked_key?.response_data?.is_auto_reminder_enabled !== undefined ? (
                      <span
                        className={`ml-1 px-2 py-0.5 text-xs rounded-full ${device.linked_key.response_data.is_auto_reminder_enabled
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                          }`}
                      >
                        {device.linked_key.response_data.is_auto_reminder_enabled ? "Yes" : "No"}
                      </span>
                    ) : (
                      <span className="ml-1 text-gray-500 text-xs">N/A</span>
                    )}
                  </div>

                  <div>
                    <span className="font-medium">Hard Reset:</span>

                    {device?.linked_key?.response_data?.is_auto_reminder_enabled !== undefined ? (
                      <span
                        className={`ml-1 px-2 py-0.5 text-xs rounded-full ${device.linked_key.response_data.is_hard_reset
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                          }`}
                      >
                        {device.linked_key.response_data.is_hard_reset ? "Yes" : "No"}
                      </span>
                    ) : (
                      <span className="ml-1 text-gray-500 text-xs">N/A</span>
                    )}
                  </div>

                  <div>
                    <span className="font-medium">Is locked:</span>

                    {device?.linked_key?.response_data?.is_locked !== undefined ? (
                      <span
                        className={`ml-1 px-2 py-0.5 text-xs rounded-full ${device.linked_key.response_data.is_locked
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                          }`}
                      >
                        {device.linked_key.response_data.is_locked ? "Yes" : "No"}
                      </span>
                    ) : (
                      <span className="ml-1 text-gray-500 text-xs">N/A</span>
                    )}
                  </div>
                </div>
                <div>
                  {qrValue && typeof device.linked_key.response_data.gateway_meta.qr_code_data === "string" ? (
                    <div>
                      <img
                        src={qr}
                        alt="QR Code"
                        className="w-25 h-25 border rounded flex flex-col items-end mr-8"
                      />
                    </div>
                  ) : (
                    <div>
                      <h4 className="mb-2 text-sm font-semibold text-gray-700 text-center">
                        Journey Details
                      </h4>

                      <div className="space-y-1 text-sm break-all">
                        {sortedJourney?.map((item, index) => (
                          <div
                            key={index}
                            className="grid grid-cols-2 gap-0 text-sm md:grid-cols-12"
                          >
                           
                            <div className="col-span-4">
                              <span
                                className={`px-2 py-0.5 text-xs rounded-full ${getStatusColor(
                                  item.state
                                )}`}
                              >
                                {item.state || "N/A"}
                              </span>
                            </div>
                            <div className="col-span-8">
                              {new Date(item.created_at).toLocaleString()}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>

            {/* Device Info */}
            <div className="p-2 border rounded-lg bg-gray-50">
              <h4 className="mb-2 text-sm font-semibold text-gray-700">Device Information</h4>
              <div className="grid grid-cols-1 gap-2 text-sm md:grid-cols-2">
                <div><span className="font-medium">Manufacturer:</span> {device?.manufacturer}</div>
                <div><span className="font-medium">Model:</span> {device?.model}</div>
                <div><span className="font-medium">IMEI 1:</span> {device?.imei_no || "N/A"}</div>
                <div><span className="font-medium">IMEI 2:</span> {device?.imei_no2 || "N/A"}</div>
              </div>
            </div>

            {/* Super Key & Key IDs */}
            <div className="p-3 border rounded-lg bg-gray-50">
              <h4 className="mb-2 text-sm font-semibold text-gray-700">Key Information</h4>
              <div className="space-y-1 text-sm break-all">
                <div><span className="font-medium">User ID:</span> {device?.linked_key?.response_data?.user_id || "N/A"}</div>
                <div><span className="font-medium">Super Key ID:</span> {device?.super_key_id || "N/A"}</div>
                <div><span className="font-medium">Key ID:</span> {device?.key_id || "N/A"}</div>
                <div><span className="font-medium">Mandate ID:</span> {device?.mandate_id || "N/A"}</div>
                <div><span className="font-medium">Mandate Status:</span>
                  <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${getStatusColor(device?.mandate_id)}`}>
                    {device?.mandate_id || "N/A"}
                  </span>
                </div>
              </div>
            </div>

            {/* FRP Info */}
            {device.frp && (
              <div className="p-3 border rounded-lg bg-gray-50">
                <h4 className="mb-2 text-sm font-semibold text-gray-700">FRP Information</h4>
                <div className="space-y-1 text-sm break-all">
                  <div><span className="font-medium">Email:</span> {device.frp.email_id || "N/A"}</div>
                  <div><span className="font-medium">Code:</span> {device.frp.email_code || "N/A"}</div>
                </div>
              </div>
            )}

            {/* Gateway Details */}
            {device?.linked_key?.response_data && device?.linked_key?.response_data?.gateway && (
              <div className="p-3 border rounded-lg bg-gray-50">
                <h4 className="mb-2 text-sm font-semibold text-gray-700">Gateway Details</h4>
                <div className="space-y-1 text-sm break-all">
                  <div><span className="font-medium">Gateway:</span>{" "} {device?.linked_key?.response_data?.gateway || "N/A"}</div>
                  <div><span className="font-medium">Gateway Reference Id:</span> {device?.linked_key?.response_data?.gateway_reference_id || "N/A"}</div>
                </div>
              </div>
            )}

            {/* Linked Key Details */}
            {device?.linked_key && device?.linked_key.key_id && (
              <div className="p-3 border rounded-lg bg-gray-50">
                <h4 className="mb-2 text-sm font-semibold text-gray-700">Linked Key Details</h4>
                <div className="grid grid-cols-2 gap-2 text-sm md:grid-cols-3">
                  <div><span className="font-medium">Version:</span> {device.linked_key.version || "N/A"}</div>
                  <div><span className="font-medium">Status:</span>
                    <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${getStatusColor(device.linked_key.status)}`}>
                      {device.linked_key.status || "N/A"}
                    </span>
                  </div>
                  <div><span className="font-medium">Linked:</span> {device.linked_key.is_linked ? "Yes" : "No"}</div>
                  <div className="col-span-2"><span className="font-medium">Last Used:</span> {formatDate(device.linked_key.last_used_at)}</div>
                </div>

                {/* FRPs List */}
                {device.linked_key.response_data?.frps && device.linked_key.response_data.frps.length > 0 && (
                  <div className="pt-2 mt-2 text-sm border-t">
                    <span className="font-medium">Additional FRPs:</span>
                    <div className="mt-1 space-y-1">
                      {device.linked_key.response_data.frps.map((frp, idx) => (
                        <div key={idx} className="p-2 text-xs bg-white border rounded">
                          <div>Email: {frp.email_id}</div>
                          <div>Code: {frp.email_code}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Gateway Meta */}
            {/* {device?.linked_key?.response_data?.gateway_meta?.qr_code_data && typeof device.linked_key.response_data.gateway_meta.qr_code_data === "string" && (
              <div className="p-3 border rounded-lg bg-gray-50">
                <span className="font-medium">QR Code:</span>
                <div className="grid grid-cols-1 gap-2 text-sm md:grid-cols-2">
                  <div>
                    <h1 className="underline font-bold">Steps:-</h1>
                    <p className="ml-10">1. Scan the QR Code</p>
                    <p className="ml-10">2. Open the link</p>
                    <p className="ml-10">3. Download APK</p>
                    <p className="ml-10">4. Install the app</p>
                    <p className="underline font-bold">Link:- </p>
                    <a
                      href={device.linked_key.response_data.gateway_meta.qr_code_data}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-1 ml-10 text-blue-600 break-all hover:underline"
                    >
                      {device.linked_key.response_data.gateway_meta.qr_code_data}
                    </a>


                    <button
                      onClick={downloadQR}
                      className="mt-2 px-3 py-2 text-xs bg-blue-500 text-white rounded"
                    >
                      Download QR
                    </button>

                  </div>
                  <div className="flex flex-col items-end mr-8">
                    {qr ? (
                      <img
                        src={qr}
                        alt="QR Code"
                        className="w-50 h-50 border rounded"
                      />
                    ) : (
                      <p>Generating QR...</p>
                    )}

                  </div>
                </div>

              </div>
            )} */}

            {/* {device?.linked_key?.response_data && device?.linked_key?.response_data?.journey && (
              <div className="p-3 border rounded-lg bg-gray-50">
                <h4 className="mb-2 text-sm font-semibold text-gray-700">Journey Details</h4>
                <div className="space-y-1 text-sm break-all">
                  {sortedJourney?.map((item, index) => (
                    <div key={index} className="grid grid-cols-2 gap-2 text-sm md:grid-cols-3">
                      <div><span className="font-medium">S.No:</span>
                        {index + 1}.
                      </div>
                      <div><span className="font-medium">Journey State:</span>
                        <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${getStatusColor(item.state)}`}>
                          {item.state || "N/A"}
                        </span>
                      </div>
                      <div><span className="font-medium">Date & Time:</span>
                        {" "} {new Date(item.created_at).toLocaleString()}
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            )} */}

            {/* Timestamps */}
            <div className="p-3 border rounded-lg bg-gray-50">
              <h4 className="mb-2 text-sm font-semibold text-gray-700">Timestamps</h4>
              <div className="grid grid-cols-1 gap-2 text-sm md:grid-cols-3">
                <div><span className="font-medium">Created:</span> {formatDate(device.created_at)}</div>
                <div><span className="font-medium">Updated:</span> {formatDate(device.updated_at)}</div>
                <div><span className="font-medium">Last Used:</span> {formatDate(device.last_used_at)}</div>
                <div><span className="font-medium">Created By:</span> {device.created_by}</div>
                <div><span className="font-medium">Updated By:</span> {device.updated_by || "N/A"}</div>
                <div><span className="font-medium">Deleted By:</span> {device.deleted_by || "N/A"}</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );

  return createPortal(modalContent, document.body);
};

export default DeviceModal;
